import { defineElement, FC, onDidLoad } from '@atomify/hooks';
import { generateQuickGuid } from '@atomify/hooks/dist/utilities';
import { h } from '@atomify/jsx';
import { useStore } from '@bpd-library/utilities';
import { AlertItem, AlertState, alertStore } from '@source/store/alert';
import { useStylesheet } from '@source/utilities/hooks';

import { BPDFunctionalSvg } from '../svg/svg';
import style from './alert.scss';

const Alert: FC = ({ element }) => {
    const [state, subscribe] = useStore<AlertState>(alertStore);

    onDidLoad(() => {
        state.alerts.forEach(renderAlert);
    });

    subscribe(({ alerts }) => {
        alerts.filter((alert) => !alert.isRendered).forEach(renderAlert);
    });

    function renderAlert(alert: AlertItem) {
        const id = `alert-${generateQuickGuid()}`;

        element.append(
            <button
                id={id}
                onClick={() => close(id)}
                class={`alert__item alert__item--${alert.type || 'success'} u-flex u-flex-between`}>
                <span class="alert__text">{alert.text}</span>
                <span class="alert__icon">
                    <BPDFunctionalSvg name="icons-close" />
                </span>
            </button>,
        );

        alert.isRendered = true;
    }

    function close(id: string) {
        const alertElement = document.querySelector(`#${id}`) as HTMLElement;
        alertElement.remove();
    }

    useStylesheet(style);
};

defineElement('bpd-alert', Alert);
